import { useContext } from 'react'
import { currentParams, stringifyParams } from 'helpers/querystring'
import { AppContext } from 'stores/App'

const useApiParams = () => {

  const [state, dispatch] = useContext(AppContext)
  const delimeter = '|'

  const currentApiParams = () => state.params

  const currentEntityParams = () => state.entity_params

  const addApiParams = (apiParams, entityParams) => {
    if (apiParams) {
      dispatch({ type: 'ADD_PARAMS', payload: apiParams + delimeter })
      console.log(`Adding ${ apiParams}`)
    }

    if (entityParams) {
      dispatch({ type: 'ADD_ENTITY_PARAMS', payload: entityParams + delimeter })
      console.log(`Adding ${ entityParams}`)
    }
  }

  const removeApiParams = (apiParams, entityParams) => {
    if (apiParams) {
      const currentParams = currentApiParams()
      const removedParams = currentParams.replace(apiParams + delimeter, '')
      dispatch({ type: 'REMOVE_PARAMS', payload: removedParams })
      console.log(`Removing: ${  apiParams}`)
    }

    if (entityParams) {
      const currentParams = currentEntityParams()
      const removedParams = currentParams.replace(entityParams + delimeter, '')
      dispatch({ type: 'REMOVE_ENTITY_PARAMS', payload: removedParams })
      console.log(`Removing: ${  entityParams}`)
    }
  }

  const updateApiParams = (apiParams, entityParams) => {
    if (apiParams) {
      dispatch({ type: 'UPDATE_PARAMS', payload: apiParams })
      console.log(`Updating: ${  apiParams}`)
    }

    if (entityParams) {
      dispatch({ type: 'UPDATE_ENTITY_PARAMS', payload: entityParams })
      console.log(`Updating: ${  entityParams}`)
    }
  }

  return {
    currentApiParams,
    addApiParams,
    removeApiParams,
    updateApiParams,
  }
}

export default useApiParams
